module.exports = __webpack_public_path__ + "img/ring_r_i_0_0.a871dcc9.png";